interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  accent?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, align = "left", accent = false }: Props) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
          <span className="h-px w-6 bg-accent-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl ${
          accent ? "text-accent-600" : ""
        }`}
      >
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}